export function formatAttendanceData(data) {
  const monthNames = {
    1: 'Janeiro',
    2: 'Fevereiro',
    3: 'Março',
    4: 'Abril',
    5: 'Maio',
    6: 'Junho',
    7: 'Julho',
    8: 'Agosto',
    9: 'Setembro',
    10: 'Outubro',
    11: 'Novembro',
    12: 'Dezembro'
  }

  const estimativeDataset = [
    {
      columns: [
        { title: 'Métrica', width: { wpx: 300 } },
        { title: 'Valor', width: { wpx: 150 } }
      ],
      data: [
        [{ value: 'Instrutores ativos' }, { value: data.activeInstructors }],
        [
          { value: 'Estimativa de atendimentos (Média anual)' },
          { value: data.totalEstimate }
        ],
        [
          { value: 'Atendimentos por instrutor (Média anual)' },
          { value: data.averagePerInstructor }
        ],
        [{ value: '' }, { value: '' }],
        [
          { value: 'Atendimentos por faixa', style: { font: { bold: true } } },
          { value: 'Quantidade', style: { font: { bold: true } } }
        ],
        ...data.rangeDistribution.map((item) => [
          { value: item.range === 'other' ? 'Outro' : item.range },
          { value: item.count }
        ])
      ]
    }
  ]

  const sortedAttendance = [...data.monthlyAttendance].sort((a, b) => {
    if (a.year !== b.year) {
      return a.year - b.year
    }
    return a.month - b.month
  })

  const monthlyAttendanceDataset = [
    {
      columns: [
        { title: 'Ano', width: { wpx: 100 } },
        { title: 'Mês', width: { wpx: 100 } },
        { title: 'Quantidade', width: { wpx: 150 } }
      ],
      data: sortedAttendance.map((item) => [
        { value: item.year },
        { value: monthNames[item.month] },
        { value: item.count }
      ])
    }
  ]

  return { estimativeDataset, monthlyAttendanceDataset }
}
